import { isPast, subHours } from 'date-fns';

export const canFinalise = shift => {
  return (
    !shift.claim_properties?.admin_sign_off && shift.most_relevant_claim_status === 'APPROVED' && isPast(shift.start_at)
  );
};

export const isUrgent = shift => {
  const now = new Date();
  const startTime = new Date(shift.start_at);
  const twoDaysBefore = subHours(startTime, 48);
  const oneDaysBefore = subHours(startTime, 24);
  if (shift.most_relevant_claim_status === 'APPROVED' && new Date(shift.end_at) < now) {
    return true;
  }
  if (['UNFILLED', 'REJECTED', 'DENIED'].includes(shift.most_relevant_claim_status) && twoDaysBefore < now) {
    return true;
  }
  if (shift.most_relevant_claim_status === 'PENDING' && oneDaysBefore < now) {
    return true;
  }
  return false;
};

export const urgencyLabel = tab => {
  if (tab === 'finalise') {
    return 'Overdue sign off';
  }
  if (tab === 'open') {
    return 'Happening soon';
  }
  if (tab === 'pending') {
    return "Select a worker for today's shift";
  }
};
